const KEY = 'dorca_last_site_id';

export function readLastSiteId(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export function writeLastSiteId(siteId: string): void {
  try { localStorage.setItem(KEY, siteId); } catch { /* ignore */ }
}

export function clearLastSiteId(): void {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
